import {useEffect} from 'react'
import {useProductSearch} from '@salesforce/commerce-sdk-react'

const AppendTiles = (props) => {
    const {
        searchParams,
        offSetValue,
        setOffSetValue,
        setTiles,
        setDisableShowMore,
        triggerSearch,
        onComplete
    } = props

    const updatedSearchParams = {
        ...searchParams,
        offset: offSetValue > 0 ? offSetValue : searchParams?.limit
    }

    const {isLoading, data: productSearchResult} = useProductSearch(
        {
            parameters: {
                ...updatedSearchParams,
                perPricebook: true,
                allVariationProperties: true,
                allImages: true,
                expand: ['promotions', 'variations', 'prices', 'images', 'custom_properties'],
                refine: updatedSearchParams._refine
            }
        },
        {
            keepPreviousData: true,
            enabled: triggerSearch
        }
    )

    useEffect(() => {
        if (productSearchResult && !isLoading) {
            const {total, hits, offset} = productSearchResult

            if (hits?.length > 0) {
                setTiles((prevData) => [...prevData, ...hits])
                setOffSetValue(offset + hits.length)

                const isLastPage = offset + hits.length >= total
                setDisableShowMore(isLastPage)
            } else {
                setDisableShowMore(true)
            }

            onComplete?.()
        }
    }, [productSearchResult, isLoading])
}

export default AppendTiles
